// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2gt9p","footer":"ModalCreateQualiphyProcedure_footer__1Q1GT","additionData":"ModalCreateQualiphyProcedure_additionData__2C2h0"};